/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Security_Passkey_DescriptionInputs */



/**
* | output |
* | --- |
* | "Passkeys let you sign in with your fingerprint, face or device PIN. Keep at least two so you are not locked out if you lose a device." |
*
* @param {Partner_Security_Passkey_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_security_passkey_description = /** @type {((inputs?: Partner_Security_Passkey_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Security_Passkey_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mit Passkeys melden Sie sich per Fingerabdruck, Gesicht oder Geräte-PIN an. Hinterlegen Sie mindestens zwei, damit Sie sich bei Verlust eines Geräts nicht aussperren.")
	return /** @type {LocalizedString} */ ("Passkeys let you sign in with your fingerprint, face or device PIN. Keep at least two so you are not locked out if you lose a device.")
});